import { speciesFor } from '../../lib/species';
import { useSpeciesPhoto } from '../../lib/speciesPhoto';
import LivingImage from '../living/LivingImage';
import SpeciesArt from './SpeciesArt';

/* Large header visual for a species detail view: living real photo with a
 * credit link, or the 3D illustration on a holographic stage. */
export default function SpeciesHero({ kind, id, wiki, emoji, name = '', className = 'aspect-[16/9]' }) {
    const sp = speciesFor(kind, id) || (wiki ? { w: wiki } : null);
    const pic = useSpeciesPhoto(sp?.w);
    return (
        <div className={`relative overflow-hidden holo-stage holo-live ${className}`}>
            {pic ? (
                <>
                    <LivingImage src={pic.url} alt={name} className="absolute inset-0 w-full h-full" referrerPolicy="no-referrer" />
                    {pic.page && (
                        <a
                            href={pic.page}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="absolute bottom-2 right-2 text-[10px] bg-black/45 text-white px-2 py-0.5 rounded-full backdrop-blur-sm"
                        >
                            Foto: Wikipedia
                        </a>
                    )}
                </>
            ) : (
                <div className="absolute inset-0 flex items-center justify-center">
                    {sp?.a
                        ? <SpeciesArt look={sp.a} seed={id} className="h-[85%] w-auto drop-shadow-xl living-float" title={name} />
                        : <span className="text-7xl living-float" role="img" aria-label={name}>{emoji || '🌱'}</span>}
                </div>
            )}
            <span className="holo-foil" aria-hidden />
        </div>
    );
}
